/*
 * @Descripttion:
 * @version:
 * @Author: LeBeryl
 * @Date: 2021-03-29 14:14:07
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-09-10 11:33:50
 */
module.exports = {
    langauge: '繁體中文',
    title0: '操作易上手',
    text0: '單手即可操作，無需過多複雜技巧，考驗路徑的選擇與彈射的角度，打出最爆炸的效果。',
    title1: '招募傳奇英雄',
    text1: '雲集眾多傳奇英雄，組建最強小隊，開拓全新套路！',
    title3: '多國即時PVP對戰',
    text3: '與世界各國的對手進行一場激烈的戰鬥，展現你最強的技巧！',
    title2: '獨特技能設定',
    text2: '每位角色富有專屬的技能，合理運用，秀翻全場！',
    title4: '多樣化場景',
    text4: '每個場景都有著隨機的機關，讓每一場對局更加的撲朔迷離，充滿刺激感。',
    news_title: '情報中心',
    home: '官方網站',
    next: '下一頁',
    pre: '上一頁',
    record: '共{total}條記錄',
    service: '服務條款',
    privacy: '隱私政策',
    top: '回頂部',
    news_langs: '語言選擇',
    news_null: '暫無數據',
    logo: '開心大碰撞',
    contact: '聯繫客服'
  }
